var map = {
	"./AndroidAppleLogo.png": "4a88",
	"./LaravelLogo.png": "3cd2",
	"./VueReactAngularLogo.png": "4537",
	"./VueReactLogo.png": "9578",
	"./awsfulllogo.jpg": "a1ab",
	"./awslogo.svg": "2bc0",
	"./conquiz.webp": "df42",
	"./csharplogo.svg": "b093",
	"./danyart.webp": "dbba",
	"./expServicePic.webp": "2b6d",
	"./jslogo.svg": "d4e2",
	"./kotlinlogo.svg": "1ccf",
	"./laravellogo.svg": "3353",
	"./main_background.svg": "f5de",
	"./main_background.webp": "cae2",
	"./particles": "9b1b",
	"./particles.json": "9b1b",
	"./penguin_engine.webp": "db5a",
	"./penguin_logo.svg": "614d",
	"./profile.webp": "cad9",
	"./profile2.png": "325c",
	"./roguelike.webp": "578a",
	"./safecrypt.webp": "5193",
	"./sharebear.webp": "15e5",
	"./vuelogo.svg": "f732"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";